import { Definition } from '../../../data/Definition';
import { Field } from '../types/types';

export interface IDeckGlLayer {
    getDeckGlLayer: (zoom: number, selected?:number, setSelected?:Function, entity?:string) => any
}

export interface IMapBoxLayer {
    getMapBoxLayer: (zoom: number) => any
}

export interface ITimeFilter {
    updateQueryForTime: (startDt: string, endDt: string) => void
}

export interface IFieldFilter {
    updateQueryForField: (field: Field | null) => void
}

export abstract class MapLayer {  
    _id: string;
    _name: string;
    _visible: boolean;
    _loading: boolean;

    constructor(id: string, name: string, visible: boolean) {
        this._id = id;
        this._name = name;
        this._visible = visible;
        this._loading = false;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    get visible() {
        return this._visible;
    }

    set visible(v: boolean) {
        this._visible = v;
    }

    get loading() {
        return this._name;
    }

    abstract load(): Promise<boolean>;
    abstract syncWithAwaited(): Promise<boolean>;
    abstract dataLoaded(): boolean;
    abstract hasError(): boolean;
    abstract getError(): string;
    abstract getColorRamp(): string | null;
    abstract getDescForObject(object: any, propertyUnitsData: any | null): string;
}